var map = {
	"./logo-1.svg": 1387,
	"./logo-2.svg": 1388,
	"./logo-3.svg": 1389,
	"./logo-4.svg": 1390,
	"./logo-5.svg": 1391,
	"./logo-6.svg": 1392,
	"./logo-7.svg": 1393,
	"./logo-8.svg": 1394
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1386;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img ^\.\/logo\-.*\.svg$
// module id = 1386
// module chunks = 4